import { AxiosResponse } from "axios";
import API from "../api";

import { AutomaticSequencing } from "../models/automatic.sequencing";
import BaseService from "./_base.service";

const endpoint = "automatic/sequences";

const AutomaticSequencingService = {
  ...BaseService<AutomaticSequencing>({ endpoint }),
  async getAll(options?: any): Promise<AxiosResponse<AutomaticSequencing[]>> {
    return API.get(`/${endpoint}`, { params: options });
  },
  async create(
    automaticSequencing: AutomaticSequencing
  ): Promise<AxiosResponse<AutomaticSequencing>> {
    return API.post(`/${endpoint}`, automaticSequencing);
  },
  async update(
    id: number,
    automaticSequencing: AutomaticSequencing
  ): Promise<AxiosResponse<boolean>> {
    return API.put(`/${endpoint}/${id}`, automaticSequencing);
  },
  async getAvailableSequence(companyId: number, options: any) {
    return API.get(`/${endpoint}/available/${companyId}`, { params: options });
  },
  async increaseSequence(sequence: AutomaticSequencing): Promise<AxiosResponse<boolean>> {
    return API.put(`/${endpoint}/increase`, sequence);
  }
};

export default AutomaticSequencingService;
